(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('fileDropzone', fileDropzone);

    /*USAGE:
    <div 
        file-dropzone="[image/png, image/jpeg, image/gif]"  // Accepted files
        file="file"                                         // Variable to bind as the file data
        file-name="fileName"                                // Variable to bind as the file name
        on-drop="callback(file, fileName)"                  // Function to call with the file data and name as parameter
        data-max-file-size="3">                             // Maximun size in MB
    </div>
    */

    fileDropzone.$inject = [];

    function fileDropzone() {

        var directive = {
            restrict: 'A',
            scope: {
                file: '=?',
                fileName: '=?',
                onDrop: '&?'
            },
            link: link
        };
        return directive;

        function link(scope, element, attrs) {
            var checkSize, isTypeValid, validMimeTypes;
            scope.onDrop = scope.onDrop? scope.onDrop() : null;

            var count = 0;
            element.bind('dragover', function (e) {
                e.stopPropagation();
                e.preventDefault();
                e.dataTransfer.dropEffect = 'copy';
                e.dataTransfer.effectAllowed = 'copy';
            });
            element.bind('dragenter', function (e) {
                e.stopPropagation();
                e.preventDefault();
                count++;
                element.addClass('dragging');
            });
            element.bind('dragleave', function (e) {
                e.stopPropagation();
                e.preventDefault();
                count--;
                if (count <= 0) {
                    element.removeClass('dragging');
                }
            });


            validMimeTypes = attrs.fileDropzone;
            checkSize = function (size) {
                var _ref;
                if (((_ref = attrs.maxFileSize) === (void 0) || _ref === '') || 
                    (size / 1024) / 1024 < attrs.maxFileSize) {
                    return true;
                } else {
                    alert('File must be smaller than ' + attrs.maxFileSize + ' MB');
                    return false;
                }
            };
            isTypeValid = function (type) {
                if ((validMimeTypes === (void 0) || validMimeTypes === '') ||
                    (type && type !== '' && validMimeTypes.indexOf(type) > -1)) {
                    return true;
                } else {
                    alert('Invalid file type.  File must be one of following types ' + validMimeTypes);
                    return false;
                }
            };

            return element.bind('drop', function (event) {
                var file, name, reader, size, type;
                if (event != null) {
                    event.preventDefault();
                }
                reader = new FileReader();
                reader.onload = function (evt) {
                    if (checkSize(size) && isTypeValid(type)) {
                        scope.file = evt.target.result;
                        scope.fileName = name;
                        if(scope.onDrop){
                            scope.onDrop(scope.file, scope.fileName);
                        }
                        scope.$apply(); // Force digest so angular can process the changes quickly
                    }
                };
                file = event.dataTransfer.files[0];
                name = file.name;
                type = file.type;
                size = file.size;
                reader.readAsDataURL(file);
                return false;
            });
        }
    }
})();